import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"
import MediumEditor from "medium-editor/dist/js/medium-editor.min.js"
import "medium-editor/dist/css/medium-editor.min.css"
import "medium-editor/dist/css/themes/beagle.min.css"

export class PageEditPost implements ClientPage {
  getPageId = (): string => "edit-post"

  execute = (): void => {
    new MediumEditor('textarea[name="description"]', {})
    new MediumEditor('textarea[name="content"]', {
      toolbar: {
        buttons: [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'subscript',
          'superscript',
          'anchor',
          'image',
          'quote',
          'pre',
          'orderedlist',
          'unorderedlist',
          'indent',
          'outdent',
          'justifyLeft',
          'justifyCenter',
          'justifyRight',
          'justifyFull',
          'h1',
          'h2',
          'h3',
          'h4',
          'h5',
          'h6',
          'removeFormat',
          'html'
        ]
      }
    })
  }

  onPageClose = (): void => {}
}
